import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLineChartIncomplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 400,
	height: 308,
	viewBox: "0 0 400 308",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 245.8H400V246.9H0V245.8Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M384 56.6L354.2 40.3C353.2 39.7 352.3 39 351.6 38L340.9 23.5C338 19.5 332.2 19.1 328.7 22.7L317.3 34.3C314.5 37.2 309.9 37.5 306.7 35L297.2 27.6C293.8 24.9 288.9 25.5 286.1 28.8L259.2 61.5C258.8 62 258.4 62.4 257.9 62.8L238.5 77.7C236.4 79.3 233.6 79.8 231 78.9L201.7 68.8C201.2 68.6 200.8 68.4 200.4 68.2L188 61.2C185.1 59.5 181.4 59.9 178.8 62.1L150.6 86.4L111 118.3C107.8 120.8 103.3 120.6 100.4 117.8L93 110.6C89.4 107.1 83.4 107.8 80.7 112.1L59 146.5C56.6 150.3 51.7 151.4 47.9 149L16 128.4",
			stroke: "#F8F8F8",
			strokeOpacity: .8,
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 119.5L61.9 136.8C62.7 137.1 63.5 137.1 64.3 136.9L108.5 125.9C109.7 125.6 111 125.9 112 126.7L122.6 135.5C123.9 136.6 125.7 136.7 127.1 135.9L155.1 119.9C155.5 119.7 156 119.5 156.4 119.4L188.6 113.9C189.7 113.7 190.6 113.1 191.2 112.2L200.5 98.8C201.2 97.9 202.2 97.2 203.3 97.1L221.6 95C222.8 94.9 223.9 94.1 224.6 93.1L237.7 71.1C238.2 70.3 239 69.7 239.9 69.4L263.9 61.4C265.5 60.9 267.2 61.4 268.3 62.7L286.2 85.1C287.8 87 290.7 87.1 292.3 85.2L323.5 49.7C325.3 47.6 328.7 48 330 50.4L345.2 78.1C346.2 79.9 348.4 80.7 350.3 79.9L384 65.9",
			stroke: "white",
			strokeOpacity: .8,
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M105 278.5C105 277.1 106.1 276 107.5 276H114.5C115.9 276 117 277.1 117 278.5V285.5C117 286.9 115.9 288 114.5 288H107.5C106.1 288 105 286.9 105 285.5V278.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173 278H121V286H173V278Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M204 278.5C204 277.1 205.1 276 206.5 276H213.5C214.9 276 216 277.1 216 278.5V285.5C216 286.9 214.9 288 213.5 288H206.5C205.1 288 204 286.9 204 285.5V278.5Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M297 278H220V286H297V278Z",
			fill: "white",
			fillOpacity: .3
		})
	]
});
export default SvgLineChartIncomplete;
